import React, { useContext } from 'react';
import { getRange } from 'lib/getRange';
import { priceFormatter, sqftFormatter } from 'src/utils/utils';
import { NO_DATA_PLACEHOLDER } from 'constants/labels';
import { BuildingPageContext } from '../../../../pages/[urlParam]/[urlBuildParam]';
import { BuildingPageContextInterface } from '../../../../apolloClient/types/Building';
import GalleryPopupHeader from './GalleryPopupHeader';

const BuildingGalleryPopupHeader: React.FC<{ onClose?: () => void }> = ({
  onClose,
}) => {
  const {
    building: { floorsCount, name, unitsCount, buildingStats },
  } = useContext(BuildingPageContext) as BuildingPageContextInterface;

  if (!buildingStats) return <div>No building stats</div>;

  const stats = [
    getRange(
      buildingStats,
      (val) => val?.minSalePrice,
      (val) => val?.maxSalePrice,
      priceFormatter
    ),
    `${getRange(
      buildingStats,
      (val) => val?.minSaleSqft,
      (val) => val?.maxSaleSqft,
      sqftFormatter
    )} sqft`,
    `${unitsCount || NO_DATA_PLACEHOLDER} units`,
    `${floorsCount || NO_DATA_PLACEHOLDER} stories`,
  ];

  return (
    <div className="relative">
      <GalleryPopupHeader name={name} stats={stats} onClose={onClose} />
    </div>
  );
};

export default BuildingGalleryPopupHeader;
